import { createContext } from 'react';
import { DateFilterEnum } from '@/ui';

export interface TaskFilterContextData {
    teamIds: Set<string>;
    userIds: Set<string>;
    deviceIds: Set<string>;
    setTeamIds: (teamIds: string[]) => void;
    setUserIds: (userIds: string[]) => void;
    setDeviceIds: (deviceIds: string[]) => void;
    onTeamFilterApplied: (teamIds: string[]) => void;
    onUserFilterApplied: (userIds: string[]) => void;
    onDeviceFilterApplied: (deviceIds: string[]) => void;
    selectedTaskId: string | null;
    setSelectedTaskId: (taskId: string | null) => void;
    timeType: DateFilterEnum;
    timeRange: { from: Date; to: Date } | null;
    timezone: string;
    setTime: (
        type: DateFilterEnum,
        range?: { from: Date; to: Date } | null
    ) => void;
}

export const TaskFilterContext = createContext<
    TaskFilterContextData | undefined
>(undefined);
